module.exports = __webpack_public_path__ + "img/img8.3b557bb4.png";